import axios from "axios";
import { attachRequestId } from "./requestId";

export const MilestonesRequest = axios.create({
    baseURL: process.env.REACT_APP_MILESTONES_API || 'https://milestones.afinidata.com'
})

attachRequestId(MilestonesRequest);
